import React, { useState, useEffect } from 'react';
import request from 'utils/request';
import Tracking from 'utils/tracking';
import { useDebounce } from 'utils/use-debounce';
import { processSuggestions } from 'utils/process-suggestions';
import { SearchEntry } from 'web-media-ui-component';

const SearchComponent = ({
    history,
    suggestionsEndpoint,
    dictionary = {},
}) => {

    const [
        suggestions,
        setSuggestions,
    ] = useState([]);
    const [
        searchValue,
        setSearchValue,
    ] = useState("");
    const debouncedSearchValue = useDebounce(searchValue, 200);
    const handleSearchChange = e => setSearchValue(e.target.value);
    const handleClearInput = () => setSearchValue('');

    useEffect(() => {

        if (debouncedSearchValue) {

            request(`${suggestionsEndpoint}${searchValue}`)
                .then(result => {

                    setSuggestions(processSuggestions(result));

                });

        } else {

            setSuggestions([]);

        }

    }, [debouncedSearchValue]);
    const onSearchSubmitHandler = (tagUrl) => {

        history.push({ ...tagUrl });
        setSuggestions([]);
        setSearchValue("");

    };
    const searchTextHolder = dictionary['typeAheadPlaceholder'] || "Search Players & Teams";
    return (
        <SearchEntry
            placeholder={searchTextHolder}
            onChangeHandler={handleSearchChange}
            onFocusHandler={Tracking.onSearchInputClick}
            onClearInputHandler={handleClearInput}
            value={searchValue}
            suggestions={suggestions}
            onSelectItem={onSearchSubmitHandler}
        />
    );

};

export default SearchComponent;
